import { render, staticRenderFns } from "./DropList.vue?vue&type=template&id=240501ed&scoped=true&"
import script from "./DropList.vue?vue&type=script&lang=js&"
export * from "./DropList.vue?vue&type=script&lang=js&"
import style0 from "./DropList.vue?vue&type=style&index=0&id=240501ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240501ed",
  null
  
)

export default component.exports